import React, { useState } from "react";
import Wordmark from "./components/Wordmark";

const C = {
  bg: "#0f2744",
  bgCard: "rgba(255,255,255,0.07)",
  text: "#ffffff",
  textSoft: "rgba(255,255,255,0.7)",
  muted: "rgba(255,255,255,0.4)",
  gold: "#F59E0B",
  border: "rgba(255,255,255,0.12)",
};

const F = {
  heading: "'Rajdhani','Sora','Segoe UI',sans-serif",
  body: "'Sora','Segoe UI',sans-serif",
};

const section = (title: string, content: React.ReactNode) => (
  <div style={{
    background: C.bgCard,
    border: `1px solid ${C.border}`,
    borderRadius: 16,
    padding: "20px 24px",
    marginBottom: 16,
  }}>
    <h2 style={{ fontSize: 16, fontWeight: 700, color: C.gold, fontFamily: F.heading, letterSpacing: 1, marginBottom: 10, marginTop: 0 }}>
      {title}
    </h2>
    <div style={{ fontSize: 13, color: C.textSoft, lineHeight: 1.7 }}>
      {content}
    </div>
  </div>
);

export default function PrivacyPage() {
  const [lang, setLang] = useState<"fi"|"en">(() => (localStorage.getItem("spinloop_lang") as "fi"|"en") || "fi");
  const toggleLang = () => setLang(l => { const n = l === "fi" ? "en" : "fi"; localStorage.setItem("spinloop_lang", n); return n; });

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(160deg, #0f2744 0%, #163b68 100%)",
      fontFamily: F.body,
      color: C.text,
      padding: "0 20px 60px",
    }}>
      <div style={{ maxWidth: 520, margin: "0 auto" }}>

        {/* Header */}
        <div style={{ paddingTop: 40, paddingBottom: 32, textAlign: "center" }}>
          <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}>
            <button onClick={toggleLang} style={{ fontSize: 20, background: "none", border: "none", cursor: "pointer", padding: 0, lineHeight: 1 }} title="Language">
              {lang === "fi" ? "🌐 EN" : "🌐 FI"}
            </button>
          </div>
          <div style={{ fontSize: 36, fontWeight: 700, fontFamily: F.heading, fontStyle: "italic", letterSpacing: 2 }}>
            <Wordmark />
          </div>
          <div style={{ fontSize: 20, fontWeight: 700, marginTop: 8, color: C.textSoft }}>
            {lang === "fi" ? "Tietosuojakäytäntö" : "Privacy Policy"}
          </div>
          <div style={{ fontSize: 11, color: C.muted, marginTop: 6 }}>
            {lang === "fi" ? "Voimassa: 7.4.2026 · Päivitetty: 7.4.2026" : "Effective: 7.4.2026 · Updated: 7.4.2026"}
          </div>
        </div>

        {lang === "fi" ? (
          <>
            {section("1. Rekisterinpitäjä", <>
              <p style={{ margin: "0 0 6px" }}><strong>DeepEnd Solutions Oy</strong></p>
              <p style={{ margin: "0 0 6px" }}>Y-tunnus: 3620565-7</p>
              <p style={{ margin: "0 0 6px" }}>Sähköposti: info@spinloop.app</p>
              <p style={{ margin: 0 }}>Verkkosivu: spinloop.app</p>
            </>)}

            {section("2. Mitä tietoja kerätään", <>
              <p style={{ margin: "0 0 8px" }}>Keräämme seuraavia tietoja palvelun käyttäjistä:</p>
              <ul style={{ margin: 0, paddingLeft: 18 }}>
                <li>Nimi (pelaajan tunnistamiseen)</li>
                <li>Sähköpostiosoite (kutsuviestit ja ilmoitukset)</li>
                <li>Puhelinnumero (valinnainen, WhatsApp-kutsuja varten)</li>
                <li>Pelitulokset ja pisteet (tilastointi)</li>
                <li>Profiilikuva (valinnainen, käyttäjän itsensä lisäämä)</li>
                <li>FCM-tunniste (push-ilmoitukset, laitteella)</li>
              </ul>
            </>)}

            {section("3. Miksi tietoja käsitellään", <>
              <p style={{ margin: "0 0 8px" }}>Tietoja käytetään yksinomaan seuraaviin tarkoituksiin:</p>
              <ul style={{ margin: 0, paddingLeft: 18 }}>
                <li>Americano-turnaustapahtumien hallinta</li>
                <li>Kutsuviestien lähettäminen pelaajille</li>
                <li>Pelitulosten ja rankings-listan ylläpito</li>
                <li>Push-ilmoitukset tapahtumista ja tuloksista</li>
              </ul>
              <p style={{ margin: "10px 0 0" }}>Käsittelyn oikeusperuste on <strong>oikeutettu etu</strong> (urheilutoiminnan järjestäminen) sekä <strong>suostumus</strong> (sähköposti-ilmoitukset).</p>
            </>)}

            {section("4. Tietojen säilytys", <>
              <p style={{ margin: "0 0 8px" }}>Tiedot tallennetaan Google Firebase Firestore -pilvipalveluun (EU-alue).</p>
              <ul style={{ margin: 0, paddingLeft: 18 }}>
                <li>Pelaajatiedot: säilytetään niin kauan kuin seura on aktiivinen</li>
                <li>Pelitulokset: säilytetään kausihistoriaa varten</li>
                <li>FCM-tunnisteet: poistetaan automaattisesti jos laite ei ole aktiivinen</li>
              </ul>
            </>)}

            {section("5. Tietojen luovuttaminen", <>
              <p style={{ margin: 0 }}>
                Tietoja ei luovuteta kolmansille osapuolille markkinointitarkoituksiin.
                Palvelun teknisessä toteutuksessa käytetään seuraavia alihankkijoita:
              </p>
              <ul style={{ margin: "8px 0 0", paddingLeft: 18 }}>
                <li>Google Firebase (tietokanta, push-ilmoitukset) — EU-alue</li>
                <li>Zoho Mail (sähköpostinlähetys) — EU-alue</li>
                <li>Cloudflare (verkkosivun tietoturva) — EU-alue</li>
                <li>Anthropic (AI-tuomarin vastaukset) — kysymyksen teksti</li>
              </ul>
              <p style={{ margin: "8px 0 0" }}>
                <strong>AI-tuomari:</strong> kun pelaaja kysyy tuomarilta, kysymyksen teksti
                lähetetään Anthropicin rajapintaan vastauksen muodostamiseksi yhdessä
                sääntötiivistelmän, klubin omien sääntöjen ja tapahtuman tietojen kanssa.
                Pelaajan nimeä, sähköpostiosoitetta tai puhelinnumeroa ei lähetetä.
                Kysymyksiä ei tallenneta palveluun: lokiin kirjataan vain kysymyksen
                pituus merkkeinä ja klubi, ei kysymyksen sisältöä.
              </p>
            </>)}

            {section("6. Evästeet ja paikallinen tallennus", <>
              <p style={{ margin: 0 }}>
                Spinloop ei käytä evästeitä (cookies). Sovellus tallentaa laitteen paikalliseen muistiin (localStorage) ainoastaan kirjautumistiedot (PIN-rooli) ja käyttäjäasetukset sovelluksen toimintaa varten. Näitä tietoja ei lähetetä ulkopuolisille.
              </p>
            </>)}

            {section("7. Käyttäjän oikeudet (GDPR)", <>
              <p style={{ margin: "0 0 8px" }}>EU:n tietosuoja-asetuksen mukaisesti sinulla on oikeus:</p>
              <ul style={{ margin: 0, paddingLeft: 18 }}>
                <li><strong>Tarkastaa</strong> omat tietosi</li>
                <li><strong>Oikaista</strong> virheelliset tiedot</li>
                <li><strong>Poistaa</strong> tietosi ("oikeus tulla unohdetuksi")</li>
                <li><strong>Rajoittaa</strong> tietojesi käsittelyä</li>
                <li><strong>Vastustaa</strong> käsittelyä</li>
                <li><strong>Siirtää</strong> tietosi toiseen palveluun</li>
              </ul>
              <p style={{ margin: "10px 0 0" }}>
                Lähetä pyyntö osoitteeseen: <strong>info@spinloop.app</strong><br />
                Vastaamme 30 päivän kuluessa.
              </p>
            </>)}

            {section("8. Tietoturva", <>
              <p style={{ margin: 0 }}>
                Tiedot siirretään aina salattuna HTTPS-yhteydellä. Firebase Firestore -tietokannan turvallisuussäännöt rajoittavat pääsyn vain sovelluksen omaan käyttöön. Zoho SMTP -sähköpostilähetys käyttää SSL-salausta.
              </p>
            </>)}

            {section("9. Muutokset tietosuojakäytäntöön", <>
              <p style={{ margin: 0 }}>
                Pidätämme oikeuden päivittää tätä tietosuojakäytäntöä. Merkittävistä muutoksista ilmoitetaan sähköpostitse tai sovelluksen kautta. Jatkamalla palvelun käyttöä hyväksyt päivitetyn käytännön.
              </p>
            </>)}
          </>
        ) : (
          <>
            {section("1. Data Controller", <>
              <p style={{ margin: "0 0 6px" }}><strong>DeepEnd Solutions Oy</strong></p>
              <p style={{ margin: "0 0 6px" }}>Business ID: 3620565-7</p>
              <p style={{ margin: "0 0 6px" }}>Email: info@spinloop.app</p>
              <p style={{ margin: 0 }}>Website: spinloop.app</p>
            </>)}

            {section("2. Data Collected", <>
              <p style={{ margin: "0 0 8px" }}>We collect the following data from service users:</p>
              <ul style={{ margin: 0, paddingLeft: 18 }}>
                <li>Name (for player identification)</li>
                <li>Email address (invitations and notifications)</li>
                <li>Phone number (optional, for WhatsApp invitations)</li>
                <li>Game results and scores (statistics)</li>
                <li>Profile picture (optional, added by the user)</li>
                <li>FCM token (push notifications, stored on device)</li>
              </ul>
            </>)}

            {section("3. Purpose of Processing", <>
              <p style={{ margin: "0 0 8px" }}>Data is used exclusively for the following purposes:</p>
              <ul style={{ margin: 0, paddingLeft: 18 }}>
                <li>Managing tournament participation</li>
                <li>Sending push notifications for game results</li>
                <li>Maintaining game results and rankings</li>
                <li>Push notifications for events and results</li>
              </ul>
              <p style={{ margin: "10px 0 0" }}>The legal basis for processing is <strong>legitimate interest</strong> (organizing sports activities) and <strong>consent</strong> (email notifications).</p>
            </>)}

            {section("4. Data Retention", <>
              <p style={{ margin: "0 0 8px" }}>Data is stored in Google Firebase Firestore (EU region).</p>
              <ul style={{ margin: 0, paddingLeft: 18 }}>
                <li>Player data: retained as long as the club account is active</li>
                <li>Game results: retained for season history</li>
                <li>FCM tokens: automatically deleted if device is inactive</li>
              </ul>
            </>)}

            {section("5. Third Parties", <>
              <p style={{ margin: 0 }}>
                Data is not shared with third parties for marketing purposes.
                The following subprocessors are used for the technical implementation:
              </p>
              <ul style={{ margin: "8px 0 0", paddingLeft: 18 }}>
                <li>Google Firebase (database, push notifications) — EU region (Google Privacy Policy applies)</li>
                <li>Zoho Mail (email sending) — EU region</li>
                <li>Cloudflare (website security) — EU region</li>
                <li>Anthropic (AI referee answers) — the text of the question</li>
              </ul>
              <p style={{ margin: "8px 0 0" }}>
                <strong>AI referee:</strong> when a player asks the referee, the text of the
                question is sent to Anthropic's API to produce the answer, together with our
                summary of the rules, the club's own rules and the details of the event. No
                player name, email address or phone number is sent. Questions are not stored
                in the service: the log records only the length of the question in characters
                and the club, not its content.
              </p>
            </>)}

            {section("6. Cookies", <>
              <p style={{ margin: 0 }}>
                Spinloop does not use cookies. The app uses localStorage for session data (PIN role) and user settings only. No tracking cookies are used and this data is not sent to third parties.
              </p>
            </>)}

            {section("7. User Rights (GDPR)", <>
              <p style={{ margin: "0 0 8px" }}>Under EU data protection regulation, you have the right to:</p>
              <ul style={{ margin: 0, paddingLeft: 18 }}>
                <li><strong>Access</strong> your personal data</li>
                <li><strong>Correct</strong> inaccurate data</li>
                <li><strong>Delete</strong> your data ("right to be forgotten")</li>
                <li><strong>Restrict</strong> processing of your data</li>
                <li><strong>Object</strong> to processing</li>
                <li><strong>Transfer</strong> your data to another service</li>
              </ul>
              <p style={{ margin: "10px 0 0" }}>
                Contact event organizer or: <strong>info@spinloop.app</strong><br />
                We respond within 30 days.
              </p>
            </>)}

            {section("8. Security", <>
              <p style={{ margin: 0 }}>
                Data is always transmitted encrypted via HTTPS. Firebase security rules restrict access to the app's own use only. Zoho SMTP email sending uses SSL encryption.
              </p>
            </>)}

            {section("9. Changes to Privacy Policy", <>
              <p style={{ margin: 0 }}>
                We reserve the right to update this privacy policy. Significant changes will be communicated by email or through the app. By continuing to use the service, you accept the updated policy.
              </p>
            </>)}
          </>
        )}

        {/* Back button */}
        <div style={{ textAlign: "center", marginTop: 32 }}>
          <a href="/" style={{
            display: "inline-block",
            padding: "12px 32px",
            background: C.gold,
            color: "#0f2744",
            borderRadius: 12,
            fontWeight: 700,
            fontSize: 14,
            textDecoration: "none",
            fontFamily: F.heading,
            letterSpacing: 1,
          }}>
            {lang === "fi" ? "← Takaisin" : "← Back"}
          </a>
        </div>

        <div style={{ textAlign: "center", marginTop: 24, fontSize: 11, color: C.muted }}>
          info@spinloop.app · spinloop.app
        </div>
      </div>
    </div>
  );
}
